<template>
  <div>
    <div v-if="isFinishLoadingPopularBrand">
      <div v-if="$SO.size(featuredBrands)" class="popular-brand">
        <h5 class="popular-brand__heading">Popular Brands</h5>
        <div class="popular-brand__list">
          <div v-for="(brand, key) in featuredBrands" :key="key" class="popular-brand__column">
            <router-link
              :to="`/brand/${brand['my_soco_sql_id']}/${$options.filters.slug(brand.name)}`"
              class="brand-logo"
            >
              <figure>
                <img
                  v-if="brand.logo"
                  :src="mainImage(brand.logo)"
                  onerror="this.src='/assets/img/default_img_brand.svg'"
                  class="brand-logo__img"
                  alt="SOCO"
                />
                <img v-else src="/assets/img/default_img_brand.svg" alt="SOCO" class="brand-logo__img" />
              </figure>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else-if="$SO.size(reviewedBrands)" class="popular-brand">
        <h5 class="popular-brand__heading">Popular Brands</h5>
        <div class="popular-brand__list">
          <div v-for="(brand, key) in reviewedBrands" :key="key" class="popular-brand__column">
            <router-link
              :to="`/brand/${brand['my_soco_sql_id']}/${$options.filters.slug(brand.name)}`"
              class="brand-logo"
            >
              <figure>
                <img
                  v-if="brand.logo"
                  :src="mainImage(brand.logo)"
                  onerror="this.src='/assets/img/default_img_brand.svg'"
                  class="brand-logo__img"
                  alt="SOCO"
                />
                <img v-else src="/assets/img/default_img_brand.svg" alt="SOCO" class="brand-logo__img" />
              </figure>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="popular-brand">
      <GFMP key="popularBrand_1" :styles="{ minHeight: '30px', marginBottom: '16px' }" />
      <GFMP key="popularBrand_2" :styles="{ minHeight: '90px', marginBottom: '16px' }" />
      <GFMP key="popularBrand_3" :styles="{ minHeight: '90px', marginBottom: '16px' }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'popular-brands',
  data() {
    return {
      reviewedBrands: [],
      featuredBrands: [],
      isFinishLoadingPopularBrand: false,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  created() {
    this.getMostReviewsBrands();
  },
  methods: {
    getMostReviewsBrands() {
      this.isFinishLoadingPopularBrand = false;
      let loadedBrandsHash = [];
      let featuredBrands = [];
      let defaultBrands = [];
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands', {
          params: {
            fields: 'my_soco_sql_id name logo featured_position',
            filter: {
              is_featured: true,
            },
            sort: 'featured_position',
            limit: 10,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            featuredBrands = response.data.data;
            this.featuredBrands = featuredBrands;
            loadedBrandsHash = loadedBrandsHash.concat(featuredBrands.map((it) => it._id));
          }
        })
        .then(() => {
          if (loadedBrandsHash.length < 10) {
            return this.$MS_SOCO_PUBLIC_API_URL
              .get('/brands', {
                params: {
                  fields: 'my_soco_sql_id name logo',
                  section: 'most-reviewed-brand',
                  filter: {
                    _id: { $nin: loadedBrandsHash },
                  },
                  sort: '-total_reviews',
                  limit: 10 - loadedBrandsHash.length,
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data) {
                  defaultBrands = response.data.data;
                }
              });
          } else {
            return;
          }
        })
        .then(() => {
          const brands = [];
          const maxLength = 10;
          let position = 0;
          let featuredPosition = 0;
          let defaultPosition = 0;

          while (position < maxLength) {
            if (featuredBrands[featuredPosition] && featuredBrands[featuredPosition].featured_position == position) {
              brands.push({
                ...featuredBrands[featuredPosition],
                featured_position: position,
              });
              featuredPosition++;
            } else if (defaultBrands[defaultPosition]) {
              brands.push({
                ...defaultBrands[defaultPosition],
                featured_position: position,
              });
              defaultPosition++;
            }
            position++;
          }

          this.reviewedBrands = brands;
          this.isFinishLoadingPopularBrand = true;
        })
        .catch((err) => {
          console.log(err);
          this.reviewedBrands = [];
          this.isFinishLoadingPopularBrand = true;
        });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=128' : 'w=144',
        image: src,
      });
    },
  },
};
</script>
